/**
 * Remove all elements equal to `value` from the array.
 */
Array.prototype.remove = function(value) {
  while (true) {
    const index = this.indexOf(value)
    if (index === -1) break
    this.splice(index, 1)
  }
}

export function arrayRemoveItemById(array, id) {
  return array.filter(function(element) {
    return element.id !== id
  })
}
